import React, { Component } from "react";
import { Container, Input, Label } from "reactstrap";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse
} from "reactstrap";
import { Button, Progress, ButtonGroup, Alert } from "reactstrap";
import { Col, Row } from "reactstrap";
import axios from 'axios';
import {
  getGPT3ParseExtractInfo,
  getGPT3CustomPromptCompletion,
  getGPT3Summarize,
  getKeyPhrases,
  getTokenOrRefresh,
} from "./token_util.js";
import { ResultReason } from "microsoft-cognitiveservices-speech-sdk";
import "./App.css";
//import { Input } from '@material-ui/core';
import BatchPage from "./batchPage.js";
import { getPrompts, getMasterAuditPrompts } from "./prompt_util.js";
import { getMediaDevices, getAudioMediaStream } from './device_util.js';
import logo from "./images/TJX-Logo.png";
import ctlogo from "./images/CTS-logo.png";
// import { ScrollContainer } from "./Components/Chat/ScrollContainer.js";
// import { ChatMessage } from "./Components/Chat/ChatMessage.js";
import { getSuggestedSolutions } from "./suggestion_util.js";
import { createIncident } from "./incidentcreation_util.js";
import SessionTimeoutWrapper from "./Components/SessionExpired/SessionTimeoutWrapper.js";

import { withMsal, useMsal } from "@azure/msal-react";
import { apiRequest, getAccessToken, msalInstance } from "./authConfig.js";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  TextAnalysisClient,
  AzureKeyCredential,
  KnownPiiEntityDomain,
  KnownPiiEntityCategory,
} from "@azure/ai-language-text";

import { uploadAudioInChunks } from "./services/chunkUploader";
import { appInsights } from "./telemetry/appInsights";
import Logger from "./telemetry/logger.js";

const speechsdk = require("microsoft-cognitiveservices-speech-sdk");
// AI Ops integration should only be enabled if the env value is true, not false or undefined.
const aiOpsEnabled = process.env.REACT_APP_AIOPS_INTEGRATION;
var micStream;
var speakerStream;
var micRecognizer;
var spkrRecognizer;
var mediaRecorder;
var summaryInterval;
//const masterAuditPromptText = getMasterAuditPrompts();

const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT ?? '';

export class App extends Component {
  constructor(props) {
    super(props);

    this.state = {language : 'en-US' };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleWindowClick = this.handleWindowClick.bind(this);
    this.toggle = this.toggle.bind(this);

    this.isMicActive = false;
    this.timerInterval = null;

    this.state = {
      displayText: "",
      displayNLPOutput: "",
      gptSummaryText: "",
      gptSummaryLines: 0,
      gptExtractedInfo: "",
      gptCustomPrompt: "",
      gptCustomPrompt2: "",
      masterAuditPrompt: "",
      showBatchPage: false,
      activeWindow: "Live",
      dropdownOpen: false,
      prompts: [],
      selectedPrompt: "",
      inputAudioDevices: [],
      activeMic: JSON.parse(localStorage.getItem("prefMic")) || undefined,
      micDropdownOpen: false,
      activeSpkr: JSON.parse(localStorage.getItem("prefSpkr")) || undefined,
      spkrDropdownOpen: false,
      summaryActive: false,
      openSuggestionsBox: false,
      openIncidentCreationBox: false,
      chatMessages: [],
      currentSuggestion: "",
      incidentDesc: "",
      speechResults: [],
      deadAirDuration: 0,
      startDateTime: null,
      callDuration: 0,
      liveDuration:0,
      startTime: null,
      startDate:null,
      isOnHold: false,
      debug: process.env.REACT_APP_NODE_ENV === "development" ? true : false,
      uploadProgress: 0 ,
      uploadStatus: "",
    };
  };

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

    toggleInputDropdown = () => {
        this.setState((prevState) => ({
            micDropdownOpen: !prevState.micDropdownOpen
        }));
    };

    toggleOutputDropdown = () => {
        this.setState((prevState) => ({
            spkrDropdownOpen: !prevState.spkrDropdownOpen
        }));
    };

    toggleActiveSummary = () => {
        this.setState((prevState) => ({
          summaryActive: !prevState.summaryActive
      }));
    };

    toggleSuggestionsBox = () => {
      this.setState((prevState) => ({
        openSuggestionsBox: !prevState.openSuggestionsBox
      }));
    };

    toggleIncidentCreationBox = () => {
      this.state.incidentDesc = `Create a new ServiceNow incident for the company <enter-company-name> with tittle <enter-incident-title> with description:${this.state.gptSummaryText}With <enter-incident-severity> severity and category of <enter-category> within channel <enter-channel> created by <enter-user-name> and assigned to <enter-user-group>`
      this.setState((prevState) => ({
        openIncidentCreationBox: !prevState.openIncidentCreationBox
      }));
    };

  handleToggle = () => {
    this.setState((prevState) => ({
      showBatchPage: !prevState.showBatchPage,
    }));
  };

  handleWindowClick = (windowName) => {
    this.setState({ activeWindow: windowName });
  };

  handleChange(event) {
    this.setState({ value: event.target.value });
    alert("You have selected conversation category : " + this.state.value);
  };

  handleSubmit(event) {
    alert(
      "Your conversation will be saved with name : " +
        this.state.value +
        " Submit a different name to change it."
    );
    event.preventDefault();
  };
 
  // Event handler for textarea changes
  handleIncidentTextChange = (event) => {
    this.setState({ incidentDesc: event.target.value });
  };

  getFreshToken = async () => { 
    const { instance, accounts } = this.props.msalContext;
    if(!accounts || accounts.length === 0) return null;

    try { 
      const response = await instance.acquireTokenSilent({ 
        scopes: [`api://${process.env.REACT_APP_SERVER_APP_CLIENT_ID}/tasks.read`, `api://${process.env.REACT_APP_SERVER_APP_CLIENT_ID}/tasks.write`],
        account: accounts[0]
      });
      return response.accessToken
    } catch (error) { 
        Logger.error("Failed to acquire fresh token:", error);
        return null;
    }
  }

  toggleHold = async () => { 

    if(!this.isMicActive) return;

    if(this.state.isOnHold){ 
      Logger.info("Resuming the call.....");
    
      if(mediaRecorder && mediaRecorder.state === "paused"){ 
        mediaRecorder.resume();
      }
    
      try{ 
        const { instance, accounts } = this.props.msalContext;
        if(!accounts || accounts.length === 0) { 
          this.setState({ displayText: "ERROR: you must be logged in to start listening."})
          return;
        }

        const token = await getAccessToken(instance, accounts[0], apiRequest);

        const tokenObj = await getTokenOrRefresh(token);
        const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(tokenObj.authToken,tokenObj.region);
        speechConfig.speechRecognitionLanguage = document.getElementById("formSelectConvLanguage").value;

        micRecognizer = new speechsdk.SpeechRecognizer(speechConfig, speechsdk.AudioConfig.fromStreamInput(this.micStream));
        spkrRecognizer = new speechsdk.SpeechRecognizer(speechConfig, speechsdk.AudioConfig.fromStreamInput(this.speakerStream));

        micRecognizer.recognized = (s, e) => this.handleRecognizedSpeech(e, "Agent")
        spkrRecognizer.recognized = (s, e) => this.handleRecognizedSpeech(e, "Caller")
        
        await micRecognizer.startContinuousRecognitionAsync();
        
        setTimeout(async() => { 
          await spkrRecognizer.startContinuousRecognitionAsync();
        },1000);
      } catch (err) { 
        Logger.error("Error recycling recognizers:", err);
      }

      this.timerInterval = setInterval(() => { 
        this.setState((prevState) => ({ 
          liveDuration: prevState.liveDuration + 1
        }))
      }, 1000);

      this.setState({ isOnHold: false});

    } else { 

      Logger.info("Placing on hold.....");

      if(mediaRecorder && mediaRecorder.state === "recording") { 
        mediaRecorder.pause();
      }

      try { 
        await micRecognizer.stopContinuousRecognitionAsync();
        micRecognizer.close();
        await spkrRecognizer.stopContinuousRecognitionAsync();
        spkrRecognizer.close();
      } catch (err) { 
        Logger.error("Error stopping recognizers for hold:", err);
      }

      if(this.timerInterval) { 
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }

      this.setState({ isOnHold: true}); 
    } 
  }

  promptList;

  async componentDidMount() {

    const {instance, accounts} = this.props.msalContext;
    
    if(!accounts || accounts.length === 0){ 
      this.setState({ displayText: "ERROR: you must logged in to satrt listening."})
      return;
    }

    const token = await getAccessToken(instance, accounts[0], apiRequest);

    this.setState({accessToken:token})

    // try {
    //   const promptList = await getPrompts(tokenResponse?.accessToken);

    //   if (promptList.prompts === null) {
    //     Logger.error("No prompt list. \n\t" + promptList.error);
    //   }

    //   if (this.state.debug){
    //     Logger.info("Successfully retrieved prompt list. " + promptList);
    //   }


    //   this.setState({ prompts: promptList.prompts });
    // } catch (error) {
    //   Logger.error("Error getting prompt list " + error);
    // }

    // check for valid speech key/region
    const tokenRes = await getTokenOrRefresh(token);
    if (tokenRes.authToken === null) {
      this.setState({
        displayText: "FATAL_ERROR amc: " + tokenRes.error,
      });
    }

    // load available devices
    const inputDevs = await getMediaDevices("audioinput");

    if (inputDevs === null || inputDevs.length === 0){
        Logger.error("No audio input devices found!");
    }

    this.setState({ inputAudioDevices: inputDevs });

    const savedMic = localStorage.getItem("prefMic");
    if (!savedMic) {
       const defaultMic = inputDevs.find(x => x.deviceId === "default");
       localStorage.setItem("prefMic", JSON.stringify(defaultMic));
       this.setState({ activeMic: defaultMic });
    } else {
       this.setState({ activeMic: JSON.parse(savedMic) });
    }

    const savedSpkr = localStorage.getItem("prefSpkr");
    if (!savedSpkr) {
       const defaultSpkr = inputDevs.find(x => x.deviceId === "default");
       localStorage.setItem("prefSpkr", JSON.stringify(defaultSpkr));
       this.setState({ activeSpkr: defaultSpkr });
    } else {
       this.setState({ activeSpkr: JSON.parse(savedSpkr) });
    }

  }

  updateSummary = () => {

    if (!this.state.summaryActive) {
      return;
    }

    const transcript =
      document.getElementById("transcriptTextarea").value;

    const transcriptLines =
      transcript.split('\n').filter(line => line.trim());

    const newLines =
      transcriptLines.slice(transcriptLines.length - this.state.gptSummaryLines);

    // Require a minimum amount of new content
    if (newLines.length < 1) {
      return;
    }

    this.gptSummarizeText(
      this.state.gptSummaryText,
      newLines.join('\n'),
      transcriptLines.length
    );
  };
  
  calculateDeadAir = () => {
   
    let totalDeadAir = 0;
    let lastEndTime = 0;
    if (this.state.debug){
      Logger.info("Starting dead air calculation...");
      Logger.info(`Speech Results: ${JSON.stringify(this.state.speechResults)}`);
      Logger.info(`Start Time: ${new Date(this.state.startTime).toLocaleString()}`);
    }
    
    this.state.speechResults.forEach((result, index) => {
      const segmentStartTime = new Date(this.state.startTime + result.offset / 10000); // Convert to milliseconds
      const segmentEndTime = new Date(segmentStartTime.getTime() + result.duration / 10000); // Convert to milliseconds

      if (this.state.debug){
        Logger.info(`Result ${index}:`);
        Logger.info(`  Text: ${result.text}`);
        Logger.info(`  Offset: ${result.offset}`);
        Logger.info(`  Duration: ${result.duration}`);
        Logger.info(`  Segment Start Time: ${segmentStartTime.toLocaleString()}`);
        Logger.info(`  Segment End Time: ${segmentEndTime.toLocaleString()}`);
      }
      
      if (index === 0) {
        // First result, initialize the lastEndTime to the end time of the first result
        lastEndTime = segmentEndTime;

        if (process.env.NODE_ENV === "development"){
          Logger.info(`  Initial lastEndTime set to: ${lastEndTime.toLocaleString()}`);
        }

      } else {
        // Calculate dead air between the end of the last segment and the start of the current segment
        if (segmentStartTime > lastEndTime) {
          const deadAir = segmentStartTime - lastEndTime;
          totalDeadAir += deadAir;
          if (this.state.debug){
            Logger.info(`  Dead Air Detected: ${deadAir} ms`);
          }
        }
        lastEndTime = segmentEndTime;
        if (this.state.debug){
          Logger.info(`  Updated lastEndTime to: ${lastEndTime.toLocaleString()}`);
        }
      }     
    });

    if (this.state.debug){
      Logger.info(`  total deadair ${totalDeadAir} ms`);
    }
    this.state.deadAirDuration = (totalDeadAir / 1000); 
  };
  
  // Function to upload the file to the API
  uploadFile = async (file) => {
    const { instance, accounts } = this.props.msalContext;
    try {
      if (!accounts || accounts.length === 0) {
        this.setState({ displayText: "ERROR: you must be logged in to stop listening." });
        return;
      }

      appInsights.trackTrace({
        message: `Stopped Listening for agent ${accounts[0].name} at ${new Date().toISOString()}. Uploading...`,
        severityLevel: 1
      });

      const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT;

      const metadata = {
        language: "en-US",
        agent: accounts[0].name,
        deadairduration: this.state.deadAirDuration,
        callduration: this.state.callDuration,
        transcript: document.getElementById("transcriptTextarea").value,
      };

      // Optional: show progress in UI
      const onProgress = ({ stage, percent, chunkIndex, totalChunks }) => {
        if (stage === "uploading" || stage === "chunk_done" || stage === "chunk_start") {
          this.setState({
            uploadProgress: percent,
            uploadStatus: chunkIndex != null
              ? `Uploading chunk ${chunkIndex + 1}/${totalChunks} (${percent}%)`
              : `Uploading... ${percent}%`,
          });
        } else if (stage === "done") {
          this.setState({ uploadStatus: "Upload complete.", uploadProgress: 100 });
        }
      };

      const result = await uploadAudioInChunks({
        file,
        msalInstance: instance,
        account: accounts[0],
        backendEndpoint: backend_endpoint,   // can be undefined for same-origin
        metadata,
        onProgress,
        chunkConcurrency: 2,                 // safest; set 2–3 if you want faster
        perChunkTimeoutMs: 30_000,           // tune based on network
        resumeIfPossible: true,
      });

      appInsights.trackTrace({
        message: `Chunk upload done for agent ${accounts[0].name} at ${new Date().toISOString()}: ${result}`,
        severityLevel: 1
      });

      Logger.info("Chunk upload done:", result);
    } catch (e) {
      appInsights.trackTrace({
        message: `Chunk upload failed for agent ${accounts[0].name} at ${new Date().toISOString()}: ${JSON.stringify(e)}`,
        severityLevel: 1
      });
      Logger.error("Chunk upload failed:", e);
      this.setState({ uploadStatus: `Upload failed: ${e.message}` });
    }
  };

  startCombinedRecording = (micStream, speakerStream) => {
    
    const audioContext = new AudioContext();
    const destination = audioContext.createMediaStreamDestination();

    audioContext.createMediaStreamSource(micStream).connect(destination);
    audioContext.createMediaStreamSource(speakerStream).connect(destination);

    mediaRecorder = new MediaRecorder(destination.stream, {mimeType: "audio/webm"})
    let chunks = [];

    mediaRecorder.ondataavailable = (event) => { 
        if(event.data.size > 0) chunks.push(event.data);
    }

    mediaRecorder.onstop = async() => { 
      const audioBlob = new Blob(chunks, {type: 'audio/webm'});
      const audioFile = new File([audioBlob], this.generateFileName(), {type: 'audio/webm'});

      try{ 
        this.uploadFile(audioFile);
        this.setState({audioBlob, audioURL : window.URL.createObjectURL(audioBlob)});
      } catch (err) { 
        Logger.error("upload failed: ", err);
      }
    }

    mediaRecorder.start();
    Logger.info("Combined audio recording started.....");
  };

  callPiiApi = async (text, token) => {
    const language = this.state.language;
    const response = await fetch(backend_endpoint + "/api/text/pii-redact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({text, language})
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    return response.json();
  };

  handleRecognizedSpeech = async (e, speakerRole) => {
    try{ 
      if(e.result.reason === ResultReason.RecognizedSpeech) { 
        const {instance, accounts} = this.props.msalContext;
    
        if(!accounts || accounts.length === 0){ 
          this.setState({ displayText: "ERROR: you must logged in to start listening."})
          return;
        }

        if (e.result.text === undefined || e.result.text === ""){
          return;
        }

        const token = await getAccessToken(instance, accounts[0], apiRequest);

        const rawText = e.result.text.replace(/\b\d{4}\b/g, '****');

        // Call your API instead of Text Analytics directly
        const { redacted } = await this.callPiiApi(rawText, token);

        const safeText = redacted || rawText;

        const newTranscriptLine = `${speakerRole}: ${safeText}\n`;
        
        this.setState((prevState) => ({
          speechResults: [
            ...prevState.speechResults,
            {
              text: safeText,
              offset: e.result.offset,
              duration: e.result.duration
            }
          ],
          displayText: prevState.displayText + newTranscriptLine,
          gptSummaryLines: prevState.gptSummaryLines + 1
        }), () => {
          const transcriptArea = document.getElementById("transcriptTextArea");
          if (transcriptArea) {
            transcriptArea.value = this.state.displayText;
            transcriptArea.scrollTop = transcriptArea.scrollHeight;
          }
        });
      } else if( e.result.reason === ResultReason.NoMatch) { 
        this.setState((prevState) => ({ 
          displayText: prevState.displayText + `\n${speakerRole}: <Recognition Failed!>`
          }), () => {
          const transcriptArea =  document.getElementById("transcriptTextArea");
          if(transcriptArea){ 
              transcriptArea.value = this.state.displayText;
              transcriptArea.scrollTop = transcriptArea.scrollHeight;
            }
        })
      }
    } catch (error) { 
      Logger.error(`Error processing speech for ${speakerRole}:`, error)
    }
  }

  async sttFromMic() { 
    this.setState({ 
      uploadProgress: 0, 
      uploadStatis: "", 
      speechResults: [], 
      gptSummaryText: "", 
      gptSummaryLines: 0,
      displayText: ""
    })

    const { instance, accounts } = this.props.msalContext;
    if(!accounts || accounts.length === 0) { 
      this.setState({ displayText: "ERROR: you must be logged in to start listening."})
      return;
    }

    appInsights.trackTrace({
      message: `Starting Listening for agent ${accounts[0].name} at ${new Date().toISOString()}...`,
      severityLevel: 1
    });

    try{ 
      const token = await getAccessToken(instance, accounts[0], apiRequest);
      
      this.setState({ accessToken: token});
      this.isMicActive = true;
      this.setState({ liveDuration: 0})

      if(this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval =setInterval(() => { 
        this.setState((prevState) => ({ liveDuration: prevState.liveDuration + 1}))
      }, 1000)

      const tokenObj = await getTokenOrRefresh(token);
      const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(tokenObj.authToken,tokenObj.region);
      speechConfig.speechRecognitionLanguage = document.getElementById("formSelectConvLanguage").value;
      
      this.micStream = await this.getAudioMediaStream(this.state.activeMic.deviceId); 
      this.speakerStream = await this.getAudioMediaStream(this.state.activeSpkr.deviceId);
      this.startCombinedRecording(this.micStream, this.speakerStream);
  
      micRecognizer = new speechsdk.SpeechRecognizer(speechConfig, speechsdk.AudioConfig.fromStreamInput(this.micStream));
      spkrRecognizer = new speechsdk.SpeechRecognizer(speechConfig, speechsdk.AudioConfig.fromStreamInput(this.speakerStream));

      micRecognizer.recognized = (s, e) => this.handleRecognizedSpeech(e, "Agent")
      spkrRecognizer.recognized = (s, e) => this.handleRecognizedSpeech(e, "Caller")

      micRecognizer.startContinuousRecognitionAsync(() => { 
        setTimeout(() => { 
          spkrRecognizer.startContinuousRecognitionAsync();
        }, 1000);
      });

      const now = new Date();
      this.setState({ 
        startDateTime: Date.now(),
        setStartTime: now.getTime(),
        startDate: now.toLocaleString(),
        summaryActive: true
      })

      summaryInterval = setInterval(this.updateSummary, 15000)

      appInsights.trackTrace({
        message: `Started Listening for agent ${accounts[0].name} at ${new Date().toISOString()}.`,
        severityLevel: 1
      });
    } catch (error) { 
      Logger.error('Error capturing audio stream:', error);

      if(error.name === "OverconstrainedError"){ 
        alert("Microphone Error: The saved microphone device is not found. Please clear your browser cache or select a different microphone in the dropdown.");
        localStorage.removeItem("prefMic");
      } else { 
        this.setState({ displayText: "Error starting audio: " + error.message })
      }
    }
  }

  async gptCustomPromptCompetion(inputText) {
    var customPromptText = document.getElementById("customPromptTextarea")
      .value;
    var transcriptInputForPmt = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3CustomPromptCompletion(
      transcriptInputForPmt,
      customPromptText
    );
    const gptText = gptObj.data.text;

    try {
      this.setState({ gptCustomPrompt: gptText.replace("\n\n", "") });
    } catch (error) {
      this.setState({ gptCustomPrompt: gptObj.data });
    }
  }

  async saveMasterAudit(inputText) {
    var customPromptText = document.getElementById("customMasterPromptTextarea")
      .value;
    var transcriptInputForPmt = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3CustomPromptCompletion(
      transcriptInputForPmt,
      customPromptText
    );
    const gptText = gptObj.data.text;

    try {
      this.setState({ masterAuditPrompt: gptText.replace("\n\n", "") });
    } catch (error) {
      this.setState({ masterAuditPrompt: gptObj.data });
    }
 
    const replacedString = this.state.masterAuditPrompt.replace(/'/g, '"');
    const now = new Date();
    const formattedDateTime = now.toLocaleString();
    const username = `&agentname=tjxuser${formattedDateTime}`
    const callduration = `&callduration=${this.state.callDuration}`
    const deadairduration = `&deadairduration=${this.state.deadAirDuration}`
    //const audit_backend_endpoint = 'http://localhost:7071/api/AuditServiceDeskLiveCall?agentname=reactapplocal'
    const audit_backend_endpoint = 'https://auditservicedesklivecall-#{CLIENTNAME}##{INSTANCE}#.azurewebsites.net/api/AuditServiceDeskLiveCall?code=#{AUDITSERVICEDESKLIVECALLFUNCTIONKEY}#'
    // const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT !== undefined ? process.env.REACT_APP_BACK_END_ENDPOINT : 'https://wapi-#{CLIENTNAME}##{INSTANCE}#-sdinsight.azurewebsites.net';

    axios.post(audit_backend_endpoint + username + callduration + deadairduration , {
        replacedString
      })
      .then(response => {
          Logger.info('API Response:', response.data);
      })
      .catch(error => {
          Logger.error('API Error:', error);
      });
    
  }

  async gptCustomPromptCompetion2(inputText) {
    var customPromptText = document.getElementById("customPromptTextarea2")
      .value;
    var transcriptInputForPmt2 = document.getElementById("transcriptTextarea")
      .value;
    //const gptObj = await getGPT3CustomPromptCompletion(inputText, customPromptText);
    const gptObj = await getGPT3CustomPromptCompletion(
      transcriptInputForPmt2,
      customPromptText
    );
    const gptText = gptObj.data.text;
    try {
      this.setState({ gptCustomPrompt2: gptText.replace("\n\n", "") });
    } catch (error) {
      this.setState({ gptCustomPrompt2: gptObj.data });
    }
  }

  generateFileName() {
    const {instance, accounts} = this.props.msalContext;
    const agentName = accounts[0].name.replace(/\s+/g, "-") ;
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    return `${agentName}_${timestamp}.webm`;
  }

  async gptSummarizeText(
    existingSummary,
    newTranscriptText,
    totalLineCount
  ) {

    const { instance, accounts } =
      this.props.msalContext;

    const freshToken =
      await getAccessToken(instance, accounts[0]);

    if (!freshToken) {
      return;
    }

    const gptObj =
      await getGPT3Summarize(
        existingSummary,
        newTranscriptText,
        freshToken
      );

    this.setState({
      gptSummaryText: gptObj.data,
      gptSummaryLines: 0
    });
  }

  async stopRecording() {
      this.isMicActive = false;

      if(mediaRecorder && mediaRecorder.state !== 'inactive'){ 
        mediaRecorder.stop();
      }

      this.updateSummary();

      if(!this.state.isOnHold) { 
        if(micRecognizer) micRecognizer.stopContinuousRecognitionAsync();
        if(spkrRecognizer) spkrRecognizer.stopContinuousRecognitionAsync();
      }

      micRecognizer.close();
      spkrRecognizer.close();

      // this.state.callDuration = (Date.now() - this.state.startDateTime) / 1000;
      if(this.timerInterval){ 
        clearInterval(this.timerInterval);
        this.timerInterval = null
      }
      this.setState({ 
        callDuration: this.state.liveDuration,
        summaryActive:false,
        isOnHold: false
      })
      this.calculateDeadAir();
      // this.setState({ summaryActive: false });
      clearInterval(summaryInterval);
  }

  formatTime = (seconds) => {
    if(!seconds) return "00 : 00"; 
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m} : ${s}`;
  }

  async gptParseExtractInfo(inputText) {
    var selectConvScenario = document.getElementById("formSelectConvScenario");
    var convScenario =
      selectConvScenario.options[selectConvScenario.selectedIndex].text;
    var transcriptInputToExtract = document.getElementById("transcriptTextarea")
      .value;
    const gptObj = await getGPT3ParseExtractInfo(
      transcriptInputToExtract,
      convScenario
    );
    //const gptObj = await getGPT3ParseExtractInfo(inputText, convScenario);
    const gptText = gptObj.data.text;
    this.setState({ gptExtractedInfo: gptText.replace("\n\n", "") });
  }

  async handleAIPromptDropdownSelect(x) {
    var element = document.getElementById("customPromptTextarea");
    element.value = x.prompt;
    this.setState({ selectedPrompt: x.name });
  }

  async handleAudioInputDropdownSelect(device) {
      //this.setState({ activeMic: deviceId })
      localStorage.setItem("prefMic", JSON.stringify(device));
      this.setState({ activeMic: device });
  }

  async handleAudioOutputDropdownSelect(device) {
      //this.setState({ activeSpkr: deviceId })
      localStorage.setItem("prefSpkr", JSON.stringify(device));
      this.setState({ activeSpkr: device });
  }

  async getAudioMediaStream(deviceId) {
    try {
      const constraints = {
        audio: {
          deviceId: deviceId ? { exact: deviceId } : undefined
        }
      };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      return stream;
    } catch (error) {
      Logger.error("Error accessing audio media stream:", error);
      throw error;
    }
  }

  handleChangeLang = (event) => { this.setState({ language: event.target.value }) };

  copySummaryToClipboard = async () => { 
    const summaryText = this.state.gptSummaryText;

    if(!summaryText) { 
      alert("No summary to Copy!");
      return;
    } 

    try { 
      await navigator.clipboard.writeText(summaryText);
      alert("summary copied to clipboard!");
    } catch (err) { 
      Logger.error("failed to copy:", err)
      alert("Failed to copy text. Please try manually.")
    }
  }

  render() {

    let pageComponent = null;

    if (this.state.showBatchPage) {
      pageComponent = (
        <BatchPage />
      );
    } else {
      pageComponent = (
        <SessionTimeoutWrapper>
        <Container className="app-container">
          <div className="card text-white bg-light mb-3 text-center">
            <span>
              <img
                className="imgbrder"
                src={ctlogo}
                alt="TJX"
                style={{
                  height: "105px",
                  width: "225px",
                }}
              />{" "}
              {/* <img
                src={logo}
                alt="TJX"
                style={{ height: "10%", width: "10%", objectFit: "cover" }}
              /> */}
            </span>
            <h3 style={{ color: "black" }}>
              Cognizant® Call Performance Analyzer - powered by WorkNext AI
            </h3>
            <p style={{ color: "black" }}>Dead Air Duration: {this.state.deadAirDuration} Seconds</p>
            <p style={{ color: "black" }}>current Call Duration: {this.formatTime(this.state.liveDuration)}</p>
            <div className="menubar">
              <div className="menu-btn-bg">
                <form className="row row-cols-lg-auto g-3 align-items-center text-white">   
                  <div style={{flex: 1, display: "flex", justifyContent:"flex-start", paddingLeft:"15px"}}>
                    <select
                      className="form-select"
                      id="formSelectConvLanguage"
                      style={{ width: "auto" }}
                      value={this.state.language} onChange={this.handleChangeLang}
                    >
                      <option value="en-US">English (USA)</option>
                      <option value="en-GB">English (UK)</option>
                      <option value="es-ES">Spanish (Spain)</option>
                      <option value="es-MX">Spanish (Mexico)</option>
                      <option value="fr-CA">French (Canada)</option>
                      <option value="fr-FR">French (France)</option>
                      <option value="it-IT">Italian (Italy)</option>
                      <option value="ja-JP">Japanese (Japan)</option>
                      <option value="da-DK">Danish (Denmark)</option>
                      <option value="wuu-CN">Chinese (Wu, Simplified)</option>
                      <option value="hi-IN">Hindi (India)</option>
                      <option value="gu-IN">Gujarati (India)</option>
                      <option value="te-IN">Telugu (India)</option>
                      <option value="de-DE">German (Germany)</option>
                      <option value="el-GR">Greek (Greece)</option>
                      <option value="ar-EG">Arabic (Egypt)</option>
                      <option value="el-GR">Greek (Greece)</option>
                      <option value="ar-IL">Arabic (Israel)</option>
                      <option value="ar-SA">Arabic (Saudi Arabia)</option>
                      <option value="cs-CZ">Czech (Czechia)</option>
                      <option value="ko-KR">Korean (Korea)</option>
                      <option value="nl-NL">Dutch (Netherlands)</option>
                      <option value="pt-BR">Portuguese (Brazil)</option>
                      <option value="pt-PT">Portuguese (Portugal)</option>
                      <option value="sv-SE">Swedish (Sweden)</option>
                      <option value="he-IL">Hebrew (Israel)</option>
                      <option value="th-TH">Thai (Thailand)</option>
                      <option value="ta-IN">Tamil (India)</option>
                      <option value="mr-IN">Marathi (India)</option>
                      <option value="pl-PL">Polish (Poland)</option>
                      <option value="nb-NO">Norwegian Bokmål (Norway)</option>
                    </select>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                      whiteSpace: "nowrap"
                    }}
                  >
                    <Button
                      style={{ marginRight: 15, width:"160px" }}
                      color="success"
                      onClick={() => { 
                        this.sttFromMic();
                        window.dispatchEvent(new Event("micActivated"));
                      }}
                      disabled={this.isMicActive}
                    >
                      Start Listening
                    </Button> 
                    <Button 
                      style={{ marginLeft: 15, marginRight:15, width:"160px"}}
                      color={this.state.isOnHold ? "warning" : "secondary"}
                      onClick={this.toggleHold}
                      disabled={!this.isMicActive}
                    > 
                      {this.state.isOnHold ? <>&#9654; Resume Call</> : <>&#9208; Hold Call</>}
                    </Button>
                    <Button
                      style={{ marginLeft: 15, width:"160px" }}
                      color="danger"
                      onClick={() => { 
                        this.stopRecording();
                        window.dispatchEvent(new Event("micDeactivated"));
                      }}
                      disabled={!this.isMicActive}
                    >
                      Stop Listening
                    </Button>
                  </div>
                  {/* <div style={{float: 'right', display:'flex'}}> */}
                  {/* <ButtonGroup>
                    <Button
                      className={
                        this.state.showBatchPage === false ? "active" : ""
                      }
                      color="danger"
                      style={{ border: 10 }}
                    >
                      Live
                    </Button>
                    <Button
                      onClick={this.handleToggle}
                      color="secondary"
                      style={{ border: 10 }}
                    >
                      Batch
                    </Button>
                  </ButtonGroup> */}

                  {/* </div> */}
                  {/* </div> */}
                  <div style={{ flex: 1}}></div>
                </form>
                    
              </div>
            </div>
          </div>

          <div className="row">
            {/* <div class="col-6">
              <div
                className="header-bg"
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginBottom: "44",
                }}
              >
                Real-time Transcription
              </div>
            </div> */}
            {/* <div class="col-6">
              <div
                className="header-bg"
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                }}
              >
                Call Insights Extraction
              </div>
            </div> */}
          </div>

          {this.state.uploadProgress > 0 && (
            <div 
                style={{ 
                      position: 'fixed', 
                      top: '20px', 
                      right: '20px', 
                      zIndex: 9999, 
                      minWidth: '320px' 
                    }}
                >
                <Alert 
                    color={this.state.uploadProgress === 100 ? "success" : "info"}
                     className="shadow"
                    >
                    <h6 className="alert-heading text-center mb-2">
                            {this.state.uploadStatus}
                    </h6>
                        { this.state.uploadProgress === 100 && ( 
                          <span 
                            onClick={() => this.setState({ uploadProgress: 0, uploadStatus:""})}
                            style={{ 
                              position:'absolute',
                              top:'3px',
                              right:'12px',
                              cursor:'pointer',
                              fontSize:'1.5rem',
                              lineHeight:'1',
                              color:'#6c757d',
                              fontWeight:'bold'
                            }}
                            aria-hidden="true"
                          >  
                            &times;
                          </span>
                        )}
                    <Progress 
                        animated={this.state.uploadProgress < 100}
                        color={this.state.uploadProgress === 100 ? "success" : "primary"} 
                        value={this.state.uploadProgress} 
                        style={{ height: '15px' }}
                      >
                        {Math.round(this.state.uploadProgress)}%
                    </Progress>
                </Alert>
                </div>
                )}
          <Row>
            <Col>
                <Dropdown id="inputDev" isOpen={this.state.micDropdownOpen} toggle={this.toggleInputDropdown}>
                    <DropdownToggle caret>
                        Select microphone device...
                    </DropdownToggle>
                    <DropdownMenu positionfixed="true">
                        {
                            this.state.inputAudioDevices && this.state.inputAudioDevices.map(x => (
                                <DropdownItem value={x.deviceId} key={x.deviceId} onClick={() => this.handleAudioInputDropdownSelect(x)} >{x.label}</DropdownItem>))
                        }
                    </DropdownMenu>
                </Dropdown>
            </Col>
            <Col>
                <label style={{ backgroundColor: 'grey' }}>Active Microphone Device: { this.state.activeMic === undefined ? "undefined" : this.state.activeMic.label } </label>
            </Col>
        </Row>
        <Row>
            <Col>
                <Dropdown id="outputDev" isOpen={this.state.spkrDropdownOpen} toggle={this.toggleOutputDropdown}>
                    <DropdownToggle caret>
                        Select speaker device...
                    </DropdownToggle>
                    <DropdownMenu positionfixed="true">
                        {
                            this.state.inputAudioDevices && this.state.inputAudioDevices.map(x => (
                                <DropdownItem value={x.deviceId} key={x.deviceId} onClick={() => this.handleAudioOutputDropdownSelect(x)} >{x.label}</DropdownItem>))
                        }
                    </DropdownMenu>
                </Dropdown>
            </Col>
            <Col>
                <label style={{ backgroundColor: 'grey' }}>Active Speaker Device: { this.state.activeSpkr === undefined ? "undefined" : this.state.activeSpkr.label } </label>
            </Col>
        </Row>

          <div
            className="row"
            style={{ resize: "vertical", overflow: "auto", marginRight: "0" }}
          >
            <div className="col-6">
              <div className="parentdiv-textara ">
                <div
                  style={{
                    color: "black",
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left",
                    marginBottom: "44",
                    background: "#d3d3d3",
                    padding: "6px",
                    borderRadius: "10px",
                  }}
                >
                  Real-time Transcription
                </div>
                <textarea
                  className="form-control"
                  id="transcriptTextarea"
                  rows="10"
                  readOnly={true}
                  value={this.state.displayText}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    marginTop: "10px",
                    borderWidth: "2px",
                    borderColor: "white",
                    borderStyle: "groove",
                    overflowY: "scroll",
                    height: "95%",
                    resize: "none",
                  }}
                  placeholder="Click Start listening and Speak to your microphone"
                />
              </div>
            </div>

            <div className="col-6 parentdiv-textara">
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  marginBottom: "10px",
                  background: "#d3d3d3",
                  borderRadius: "10px",
                  padding:"1px"
                }}
              >
                <Col style={{marginLeft:"5px"}}>
                  Active Summary
                </Col>
                <Col>
                  <Input type="checkbox" checked={this.state.summaryActive} onChange={this.toggleActiveSummary}/>
                  {/* <Input type="checkbox" checked={this.state.summaryActive} onClick={() => this.toggleActiveSummary()}/> */}
                  <Label style={{ color: "black", paddingLeft: 5 }}>Enable/Disable</Label>
                </Col>

                <div style={{ display:'flex', marginLeft:'2px'}}> 
                  <Button 
                    color="light"
                    size="sm"
                    onClick={this.copySummaryToClipboard}
                    style={{ 
                      display:"flex",
                      alignItems:"center",
                      borderRadius:"10px"
                    }}
                  > 
                     📋 
                  </Button>
                 <div style={{paddingLeft: 5}}>Copy</div>
                </div>

                <Col>
                  <Button onClick={this.toggleSuggestionsBox} disabled={!aiOpsEnabled} hidden={!aiOpsEnabled}>Toggle AI Ops Interface</Button>
                </Col>
                <Col>
                  <Button onClick={this.toggleIncidentCreationBox} disabled={!aiOpsEnabled} hidden={!aiOpsEnabled}>Create Incident</Button>
                </Col>
              </div>
              
              <code
                className="form-control textarea"
                contentEditable="true"
                suppressContentEditableWarning={true}
                style={{
                  color: "black",
                  overflowY: "scroll",
                  height: "87%",
                  marginTop: "10px",
                }}
              >
                {this.state.gptSummaryText}
              </code>
            </div>
          </div>

          <div
            style={{
              color: "black",
              fontSize: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            .
          </div>
          <div>
            <Collapse 
              isOpen={this.state.openSuggestionsBox}>
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  backgroundColor: "#111827",
                  padding: "20px"
                }}
              >
                <textarea
                  readOnly={true}
                  value={this.state.currentSuggestion}
                  style={{
                    width: "90%",
                    minHeight: "200px"
                  }}/>
                <div
                  style={{
                    marginTop: "8px"
                  }}
                >
                  <Button 
                    onClick={async () => {
                      const {instance, accounts} = this.props.msalContext;
                      const freshToken = await getAccessToken(instance, accounts[0], apiRequest);
                        if(freshToken){ 
                          var suggestion = getSuggestedSolutions(this.state.gptSummaryText, freshToken);
                          suggestion.then((res) => {
                          this.setState({ currentSuggestion : res.response });
                        });
                        }
                      }
                    }
                  >
                    Suggest Solutions
                  </Button>
                </div>
              </div>
            </Collapse>
          </div>
          <div>
            <Collapse 
              isOpen={this.state.openIncidentCreationBox}>
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  backgroundColor: "#111827",
                  padding: "20px"
                }}
              >
                <textarea
                  id="incidentTextarea"
                  value={this.state.incidentDesc}
                  onChange={this.handleIncidentTextChange} // Handle value changes
                  style={{
                    width: "90%",
                    minHeight: "200px"
                  }}/>
                <div
                  style={{
                    marginTop: "8px"
                  }}
                >
                  <Button 
                    onClick={
                      () => {
                        var incidentdesc = createIncident(this.state.incidentDesc);
                        incidentdesc.then((res) => {
                          this.setState({ incidentDesc : res.response });
                        });
                      }
                    }
                  >
                    Create Incident
                  </Button>
                </div>
              </div>
            </Collapse>
          </div>
          {/* <div
            style={{
              color: "black",
              fontSize: 18,
              display: "flex",
              justifyContent: "center",
            }}
          >
            BYOP (Bring Your Own Prompt) to extract business insights
          </div> */}
          {/* <div
            style={{
              color: "black",
              fontSize: 5,
              display: "flex",
              justifyContent: "center",
            }}
          >
            .
          </div> */}
          {/* <div
            class="row text-dark"
            style={{
              resize: "vertical",
              overflow: "auto",
            }}
          > */}
            {/* <div class="col-6 " style={{ position: "relative" }}> */}
              {/* <div
                className="header-bg"
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginBottom: "44",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                }}
              >
                <Col>
                  <Dropdown
                    id="promptName"
                    isOpen={this.state.dropdownOpen}
                    toggle={this.toggle}
                  >
                    <DropdownToggle caret>
                      Select a Pre-defined Prompt
                    </DropdownToggle>
                    <DropdownMenu positionfixed={true}>
                      {this.state.prompts &&
                        this.state.prompts.map((x) => (
                          <DropdownItem
                            value={x.prompt}
                            onClick={() =>
                              this.handleAIPromptDropdownSelect(x.prompt)
                            }
                          >
                            {x.name}
                          </DropdownItem>
                        ))}
                    </DropdownMenu>
                  </Dropdown>
                </Col>
                <Col>
                  <Button
                    style={{ position: "absolute", right: 0, marginRight: 15 }}
                    color="primary"
                    onClick={() =>
                      this.gptCustomPromptCompetion(this.state.displayText)
                    }
                  >
                    Extract Insights
                  </Button>
                </Col>
              </div> */}

              {/* <div className="parentdiv-textara">
                <div
                  className="header-bg"
                  style={{
                    color: "black",
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left",
                    marginBottom: "8px",
                    background: "#d3d3d3",
                    padding: "6px",
                    borderRadius: "10px",
                  }}
                >
                  <Col>
                    <Dropdown
                      id="promptName"
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggle}
                    >
                      <DropdownToggle caret>
                        {this.state.selectedPrompt
                          ? this.state.selectedPrompt
                          : "Select a Pre-defined Prompt"}
                      </DropdownToggle>

                      <DropdownMenu positionfixed={true}>
                        {this.state.prompts &&
                          this.state.prompts.map((x) => (
                            <DropdownItem
                              value={x.prompt}
                              onClick={() =>
                                this.handleAIPromptDropdownSelect(x)
                              }
                            >
                              {x.name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                  <Col>
                    <Button
                      style={{
                        position: "absolute",
                        right: 0,
                        marginRight: 35,
                      }}
                      color="primary"
                      onClick={() =>
                        this.gptCustomPromptCompetion(this.state.displayText)
                      }
                    >
                      Extract Insights
                    </Button>
                  </Col>
                </div>
                <textarea
                  class="form-control"
                  id="customPromptTextarea"
                  rows="10"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderWidth: "2px",
                    borderColor: "white",
                    borderStyle: "groove",
                    overflowY: "scroll",
                    height: "72%",
                    resize: "none"
                  }}
                >
                  Enter a prompt here
                </textarea>
              </div> */}
            {/* </div> */}
            {/* <div className="col-6 parentdiv-textara" style={{ width: "49%" }}>
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginBottom: "44",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              >
                Prompt Response
              </div>
              <code
                class="form-control "
                style={{ color: "black", overflowY: "scroll", height: "87%", whiteSpace: "pre-wrap" }}
              >
                {this.state.gptCustomPrompt}
              </code>
            </div> */}
          {/* </div>
          <p> </p> */}
          {/* <div
            style={{
              color: "black",
              fontSize: 18,
              display: "flex",
              justifyContent: "center",
            }}
          >
            Extract and Save Master Audit Parameters
          </div>
          <div
            style={{
              color: "black",
              fontSize: 5,
              display: "flex",
              justifyContent: "center",
            }}
          >
          </div> */}
          {/* <div
            class="row text-dark"
            style={{
              resize: "vertical",
              overflow: "auto",
            }}
          >
            <div class="col-6 " style={{ position: "relative" }}>
              
              <div className="parentdiv-textara">
                <div
                  className="header-bg"
                  style={{
                    color: "black",
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left",
                    marginBottom: "8px",
                    background: "#d3d3d3",
                    padding: "6px",
                    borderRadius: "10px",
                    height:"50px"
                  }}
                >
                  <Col>Predifened Master Audit Prompt</Col>
                  <Col>
                    <Button
                      style={{
                        position: "absolute",
                        right: 0,
                        marginRight: 35,
                      }}
                      color="primary"
                      onClick={() =>
                        this.saveMasterAudit(this.state.displayText)
                      }
                    >
                      Extract/Save Master Audit
                    </Button>
                  </Col>
                </div>
                <textarea
                  class="form-control"
                  id="customMasterPromptTextarea"
                  rows="10"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    borderWidth: "2px",
                    borderColor: "white",
                    borderStyle: "groove",
                    overflowY: "scroll",
                    height: "72%",
                    resize: "none"
                  }}
                  value={masterAuditPromptText}
                >
                  
                </textarea>
              </div>
            </div>
            <div className="col-6 parentdiv-textara" style={{ width: "49%" }}>
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginBottom: "44",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              >
                Prompt Response
              </div>
              <code
                class="form-control "
                style={{ color: "black", overflowY: "scroll", height: "87%", whiteSpace: "pre-wrap" }}
              >
                {this.state.masterAuditPrompt}
              </code>
            </div>
          </div> */}
          {/* <p> </p> */}
          
          {/* <div
            class="row text-dark  "
            style={{ resize: "vertical", overflow: "auto", minHeight: 300 }}
          >
            <div class="col-6">
              <div class="parentdiv-textara">
                <div
                  style={{
                    color: "black",
                    fontSize: 16,

                    justifyContent: "left",
                    alignItems: "left",
                    marginBottom: "44",
                    background: "#d3d3d3",
                    padding: "6px",
                    borderRadius: "10px",
                  }}
                >
                  {" "}
                  <label
                    for="customPromptTextarea"
                    class="form-label"
                    style={{ color: "black" }}
                  >
                    Enter your custom prompt:
                  </label>
                  <button
                    type="button"
                    class="btn btn-info btn-sm float-end btn-primary"
                    onClick={() =>
                      this.gptCustomPromptCompetion2(this.state.displayText)
                    }
                  >
                    Extract Insights
                  </button>
                </div>

                <div>
                  <textarea
                    class="form-control"
                    id="customPromptTextarea2"
                    rows="10"
                    style={{
                      backgroundColor: "white",
                      color: "black",
                      borderWidth: "2px",
                      borderColor: "white",
                      borderStyle: "groove",
                      overflowY: "scroll",
                      height: "80%",
                      resize: "none",
                    }}
                  >
                    Enter a prompt here
                  </textarea>
                </div>
              </div>
            </div>

            <div className="col-6 parentdiv-textara" style={{ width: "49%" }}>
              <div
                style={{
                  color: "black",
                  fontSize: 16,
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  marginBottom: "44",
                  background: "#d3d3d3",
                  padding: "6px",
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              >
                Prompt Response
              </div>
              <code
                class="form-control"
                style={{
                  color: "black",
                  overflowY: "scroll",
                  marginRight: "0",
                  height: "84%",
                }}
              >
                {this.state.gptCustomPrompt2}
              </code>
            </div>
          </div> */}
        </Container>
        </SessionTimeoutWrapper>
      );
    }
    return <div>{pageComponent}</div>;
  }

}
export default withMsal(App);